import { Entity } from '@inter-ikea-core/core';
import { CoreApi, Product } from '@inter-ikea-storageone/range';

const replaceDoors = (
  coreApi: CoreApi,
  newFrame: Entity,
  doorsMatchingPreviousDoors: { doors: Product[]; handleId?: string }[],
  isSlidingDoor?: boolean,
  slidingDoorFrames?: Entity[]
) => {
  const productsToAdd = doorsMatchingPreviousDoors.flatMap(doorMatchingPreviousDoor => {
    return doorMatchingPreviousDoor.doors.map(door => {
      return {
        id: door.coreProductId,
        handleId: doorMatchingPreviousDoor.handleId
      };
    });
  });

  productsToAdd.forEach(productToAdd => {
    if (!productToAdd.id) return;
    let placementResult;

    if (isSlidingDoor && slidingDoorFrames) {
      placementResult = coreApi.products.addToTargets(productToAdd.id, slidingDoorFrames);
    } else {
      placementResult = coreApi.products.addToTarget(productToAdd.id, newFrame);
    }

    if (!placementResult.valid) {
      coreApi.createConflict(
        placementResult,
        productToAdd.handleId ? [productToAdd.handleId] : undefined
      );
    }

    if (placementResult.valid && placementResult.placedEntity && productToAdd.handleId) {
      coreApi.products.addToTarget(productToAdd.handleId, placementResult.placedEntity);
    }
  });
};

export default replaceDoors;
